import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, inject } from "vue";
import router from "@/router/index";
// import { useUserStore } from "@/stores/userStore";
import { Form } from "vee-validate";
import {
  Address,
  AddressType,
  PROVIDE_KEY_SHOW_TOAST_MESSAGE,
  ShowToastMessage,
} from "@/types";
import Page from "@/components/shared/Page.vue";
import NavigationBar from "@/components/shared/NavigationBar.vue";
import AddressInput from "@/components/shared/inputs/AddressInput.vue";
import BaseButton from "@/components/shared/button/base/BaseButton.vue";
import KakaoAddressModal from "@/components/shared/modal/KakaoAddressModal.vue";
import PageModal from "@/components/shared/modal/base/PageModal.vue";


const __default__ = {
  name: "ChangeAddress",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  label: {
    type: String,
  },
  addressType: {
    type: String,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const showToastMessage = inject(
  PROVIDE_KEY_SHOW_TOAST_MESSAGE
) as ShowToastMessage;

// const userStore = useUserStore();
const currentRoadAddress = ref("경기 성남시 분당구 판교로255번길 62");
const address = ref<Address>({
  dongAddress: "",
  dongNo: "",
  roadAddress: "",
  roadNo: "",
  zipNo: "",
  detailAddress: "",
  lat: 0,
  lng: 0,
});
const isShowAddress = ref(false);
const toggleAddressModal = (show: boolean) => {
  isShowAddress.value = show;
};

const schema = computed(() => {
  return {
    address: `required:${props.label}를|newAddress:${currentRoadAddress.value}`,
  };
});

const updateAddress = (addressValue: Address) => {
  address.value = addressValue;
};

const onClickChangePassword = async () => {
  // TODO 주소 변경 API 호출
  if (props.addressType === AddressType.Home) {
    // 자택 주소 변경
  } else if (props.addressType === AddressType.Office) {
    // 회사 주소 변경
  }
  showToastMessage("주소가 변경되었습니다", 3000, 350);
  router.back();
};

const __returned__ = { props, showToastMessage, currentRoadAddress, address, isShowAddress, toggleAddressModal, schema, updateAddress, onClickChangePassword, get Form() { return Form }, Page, NavigationBar, AddressInput, BaseButton, KakaoAddressModal, PageModal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})